{
  "bell_label": "Xibaar yi",
  "panel_title": "Xibaar yi",
  "mark_all_read": "Jàngal yépp",
  "empty": {
    "title": "Amul xibaar",
    "description": "Dinga jot fii yeneen xibaar ci sa komand yi ak promo yi."
  },
  "types": {
    "order_confirmed": "Komand bi dëgg na",
    "order_shipped": "Komand bi ngi ci yoon",
    "order_delivered": "Komand bi agsi na",
    "payment_received": "Fey bi jot na",
    "payment_failed": "Fey bi jotul",
    "return_approved": "Retuur bi nangu nañu ko",
    "return_rejected": "Retuur bi bañ nañu ko",
    "promo": "Promosion",
    "loyalty_milestone": "Fidélité",
    "stock_alert": "Alerte stock",
    "welcome": "Dalal jàmm"
  },
  "channels": {
    "sms": "SMS",
    "whatsapp": "WhatsApp",
    "email": "E-mail",
    "push": "Notification push",
    "in_app": "Ci biir appli bi"
  },
  "languages": {
    "fr": "Français",
    "wo": "Wolof",
    "en": "English"
  },
  "preferences": {
    "channels_title": "Yoonu xibaar yi",
    "channels_description": "Tànnal naka ngay bëgg jot sa xibaar yi.",
    "quiet_hours_title": "Waxtu bu dëggu",
    "quiet_hours_description": "Dunu la yonnee xibaar push walla SMS ci waxtu bii.",
    "quiet_start": "Tambali",
    "quiet_end": "Jeex",
    "language_title": "Làkku xibaar yi",
    "save": "Denc",
    "saving": "Ñuy denc..."
  },
  "timeAgo": {
    "now": "Léegi léegi",
    "minutes_one": "{{count}} simili ci ginnaaw",
    "minutes_other": "{{count}} simili ci ginnaaw",
    "hours_one": "{{count}} waxtu ci ginnaaw",
    "hours_other": "{{count}} waxtu ci ginnaaw",
    "days_one": "{{count}} fan ci ginnaaw",
    "days_other": "{{count}} fan ci ginnaaw"
  }
}
